import { useCountUp } from '../../../hooks/useCountUp';

export default function TrustSection() {
  const years = useCountUp(10);
  const projects = useCountUp(500);
  const satisfaction = useCountUp(100);

  return (
    <section className="py-12 sm:py-16 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 px-2">
            Tu empresa de confianza en <a href="https://es.wikipedia.org/wiki/Vic" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline break-words">Vic y Osona</a>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Más de una década ofreciendo soluciones profesionales de vaciado y limpieza en toda la comarca
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
          <article ref={years.ref} className="text-center px-4">
            <div className="text-4xl sm:text-5xl font-bold text-primary mb-2" aria-label="Más de 10 años de experiencia">
              +{years.count}
            </div>
            <div className="text-sm sm:text-base font-semibold text-dark mb-1">Años de experiencia</div>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Profesionales especializados en vaciado de pisos y limpieza extrema en Vic y Osona
            </p>
          </article>

          <article ref={projects.ref} className="text-center px-4">
            <div className="text-4xl sm:text-5xl font-bold text-primary mb-2" aria-label="Más de 500 pisos vaciados">
              +{projects.count}
            </div>
            <div className="text-sm sm:text-base font-semibold text-dark mb-1">Pisos vaciados</div>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Viviendas, locales comerciales y trasteros completamente vaciados y limpiados
            </p>
          </article>

          <article ref={satisfaction.ref} className="text-center px-4">
            <div className="text-4xl sm:text-5xl font-bold text-primary mb-2" aria-label="100% de satisfacción">
              {satisfaction.count}%
            </div>
            <div className="text-sm sm:text-base font-semibold text-dark mb-1">Satisfacción</div>
            <p className="text-xs sm:text-sm text-gray-600 break-words">
              Clientes satisfechos con nuestro servicio discreto y profesional
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
